import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchData } from "../../../utils/functions";
import { FaMale, FaFemale } from "react-icons/fa";
import { FaTransgender } from "react-icons/fa6";

const AllBeneficiaries = ({ filters }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [educationData, setEducationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const useCountUp = (end, duration = 1000) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!end) {
        setCount(0);
        return;
      }
      let start = 0;
      const increment = end / (duration / 16);
      const step = () => {
        start += increment;
        if (start < end) {
          setCount(Math.ceil(start));
          requestAnimationFrame(step);
        } else {
          setCount(end);
        }
      };
      requestAnimationFrame(step);
    }, [end, duration]);

    return count;
  };
    const fetchEducationData = async () => {
    setLoading(true);
    try {
      const response = await fetchData(
        "household-age-group-distribution", 
        "GET",
        null,
        {},
        filters || {}, 
        navigate,
        "/household-age-group-distribution",
        dispatch
      );

      setEducationData(response?.data || null);
    } catch (error) {
      console.error("Error fetching education data:", error);
      setEducationData(null);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (filters) {
      fetchEducationData();
    }
  }, [JSON.stringify(filters)]);
const maleTotal = Object.values(
    educationData?.educationByGender?.male || {}
  ).reduce((sum, val) => sum + (val || 0), 0);
  const femaleTotal = Object.values(
    educationData?.educationByGender?.female || {}
  ).reduce((sum, val) => sum + (val || 0), 0);
  const otherTotal = Object.values(
    educationData?.educationByGender?.other || {}
  ).reduce((sum, val) => sum + (val || 0), 0);
  const totalCount = maleTotal + femaleTotal + otherTotal;

  const calculateEducationLevelCount = (level) => {
    const male = educationData?.educationByGender?.male?.[level] || 0;
    const female = educationData?.educationByGender?.female?.[level] || 0;
    const other = educationData?.educationByGender?.other?.[level] || 0;
    return male + female + other;
  };

  const preschool = calculateEducationLevelCount("Pre-school/Katchi");
  const primary = calculateEducationLevelCount("Primary (five years)");
  const lowerSecondary = calculateEducationLevelCount("Lower Secondary");
  const upperSecondary = calculateEducationLevelCount("Upper Secondary");
  const higherSecondary = calculateEducationLevelCount("Higher Secondary");
  const graduate = calculateEducationLevelCount("Graduate/Above");
  const nonEducated = calculateEducationLevelCount("Non-Educated");

  const maleCount = useCountUp(maleTotal);
  const femaleCount = useCountUp(femaleTotal);
  const transgenderCount = useCountUp(otherTotal);
  const totalAnimated = useCountUp(totalCount);
  const preschoolAnimated = useCountUp(preschool);
  const primaryAnimated = useCountUp(primary);
  const lowerSecondaryAnimated = useCountUp(lowerSecondary);
  const upperSecondaryAnimated = useCountUp(upperSecondary);
  const higherSecondaryAnimated = useCountUp(higherSecondary);
  const graduateAnimated = useCountUp(graduate);
  const nonEducatedAnimated = useCountUp(nonEducated);

  if (loading) {
    return (
      <div className="text-center py-10 text-gray-500">
        Loading beneficiaries data...
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex flex-col justify-center items-center">
        <div className="flex flex-wrap justify-center w-full mb-6 text-center">
          <div className="w-1/3 p-2">
            <div>
              <FaMale className="text-6xl mx-auto [color:oklch(0.511_0.096_186.391)]" />
              <div className="text-3xl font-bold">{maleCount}</div>
              <div className="text-sm text-gray-500">Male</div>
            </div>
          </div>

          <div className="w-1/3 p-2">
            <div>
              <FaFemale className="text-6xl mx-auto [color:oklch(0.511_0.096_186.391)]" />
              <div className="text-3xl font-bold">{femaleCount}</div>
              <div className="text-sm text-gray-500">Female</div>
            </div>
          </div>

          <div className="w-1/3 p-2">
            <div>
              <FaTransgender className="text-6xl mx-auto [color:oklch(0.511_0.096_186.391)]" />
              <div className="text-3xl font-bold">{transgenderCount}</div>
              <div className="text-sm text-gray-500">Transgender</div>
            </div>
          </div>
        </div>

        <div
          className="grid grid-cols-2 gap-4 rounded w-full mb-6 p-4"
          style={{ backgroundColor: "#ebebeb", borderRadius: "8px" }}
        >
          <div className="text-center">
            <h3 className="text-3xl font-bold">{preschoolAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Pre-school/Katchi</h4>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold">{primaryAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Primary (five years)</h4>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold">{lowerSecondaryAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Lower Secondary</h4>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold">{upperSecondaryAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Upper Secondary</h4>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold">{higherSecondaryAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Higher Secondary</h4>
          </div>
          <div className="text-center">
            <h3 className="text-3xl font-bold">{graduateAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Graduate/Above</h4>
          </div>
          <div className="text-center col-span-full justify-self-center">
            <h3 className="text-3xl font-bold">{nonEducatedAnimated}</h3>
            <h4 className="text-sm text-gray-600 mt-1">Non-Educated</h4>
          </div>
        </div>

        <div className="w-full text-center mt-3">
          <h3 className="text-lg font-semibold">
            Total: <span className="font-bold">{totalAnimated}</span>
          </h3>
          <br/>
        </div>
      </div>
    </div>
  );
};

export default AllBeneficiaries;
